import consts from "src/config/consts";
import { Line } from "src/types/storefront/Cart";

export default function isAllCartItemsGifts(cartItems: Line[] | undefined) {
  return cartItems?.every((item) =>
    item.merchandise.sku.startsWith(consts.GIFT_CARD_SKU_PREFIX)
  );
}
